// =============================================================
// glitch.js — visual + GSAP-driven glitch when looping 5->1 / 1->5
// =============================================================

const overlay = () => document.getElementById("glitch-overlay");
const track = () => document.querySelector(".slides-track");

/**
 * Trigger glitch FX. Combines CSS keyframes + GSAP timeline if available.
 * @param {Object} opts
 * @param {number} [opts.duration=0.6] seconds
 * @param {Function} [opts.onMid] callback at midpoint (good for slide swap)
 */
export function triggerGlitch({ duration = 0.6, onMid } = {}) {
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    if (onMid) onMid();
    return;
  }

  const ov = overlay();
  const tr = track();
  if (!ov) {
    if (onMid) onMid();
    return;
  }

  // CSS-only glitch
  ov.classList.remove("is-glitching");
  void ov.offsetWidth; // restart animation
  ov.classList.add("is-glitching");

  if (tr) {
    tr.classList.remove("is-loop-glitch");
    void tr.offsetWidth;
    tr.classList.add("is-loop-glitch");
  }

  // GSAP enhancement (extra shake / scale punch)
  if (window.gsap && tr) {
    const tl = window.gsap.timeline();
    tl.to(tr, {
      x: "+=12",
      duration: 0.06,
      ease: "steps(2)",
      yoyo: true,
      repeat: 4,
    })
      .to(tr, {
        scale: 1.015,
        duration: 0.18,
        ease: "power2.out",
      }, "<")
      .to(tr, {
        scale: 1,
        x: 0,
        duration: 0.25,
        ease: "power3.out",
      });
  }

  const midDelay = (duration * 0.4) * 1000;
  const endDelay = duration * 1000;

  if (onMid) setTimeout(onMid, midDelay);

  setTimeout(() => {
    ov.classList.remove("is-glitching");
    if (tr) tr.classList.remove("is-loop-glitch");
  }, endDelay);
}
